import { jsx as _jsx } from "react/jsx-runtime";
import { reportErrorToBugsnag } from "@air/utils-error";
import noop from "lodash/noop";
import { createContext, memo, useContext, useMemo, useState } from "react";
import { isDevOrTestStage } from "~/swr-hooks/utils";
const defaultValue = {
    searchState: {
        totalResults: 0,
        isSearching: false,
        currentResultIndex: -1
    },
    triggerSearch: noop,
    triggerClearSearch: noop,
    setCurrentResult: noop,
    updateSearchState: noop,
    setSearchFunctions: noop
};
const PDFSearchBridgeContext = /*#__PURE__*/ createContext(defaultValue);
export const PDFSearchBridgeContextProvider = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    const [searchState, setSearchState] = useState(defaultValue.searchState);
    const [searchFunctions, setSearchFunctions] = useState({});
    const value = useMemo(()=>({
            searchState,
            triggerSearch: (phrase)=>{
                var _searchFunctions_onSearchPhraseChange;
                return (_searchFunctions_onSearchPhraseChange = searchFunctions.onSearchPhraseChange) === null || _searchFunctions_onSearchPhraseChange === void 0 ? void 0 : _searchFunctions_onSearchPhraseChange.call(searchFunctions, phrase);
            },
            triggerClearSearch: ()=>{
                var _searchFunctions_clearSearch;
                return (_searchFunctions_clearSearch = searchFunctions.clearSearch) === null || _searchFunctions_clearSearch === void 0 ? void 0 : _searchFunctions_clearSearch.call(searchFunctions);
            },
            setCurrentResult: (index)=>{
                var _searchFunctions_setCurrentResultIndex;
                return (_searchFunctions_setCurrentResultIndex = searchFunctions.setCurrentResultIndex) === null || _searchFunctions_setCurrentResultIndex === void 0 ? void 0 : _searchFunctions_setCurrentResultIndex.call(searchFunctions, index);
            },
            updateSearchState: setSearchState,
            setSearchFunctions
        }), [
        searchState,
        searchFunctions
    ]);
    return /*#__PURE__*/ _jsx(PDFSearchBridgeContext.Provider, {
        value: value,
        children: children
    });
});
PDFSearchBridgeContextProvider.displayName = "PDFSearchBridgeContextProvider";
export const usePDFSearchBridgeContext = ()=>{
    const context = useContext(PDFSearchBridgeContext);
    const error = new Error("usePDFSearchBridgeContext must be used within a PDFSearchBridgeContextProvider");
    if (context === defaultValue) {
        if (isDevOrTestStage()) {
            throw error;
        } else {
            reportErrorToBugsnag({
                error,
                context: error.message
            });
        }
    }
    return context;
};
